import React from "react";
import { Link, useNavigate } from "react-router-dom";

const MANROPE = { fontFamily: '"Manrope", sans-serif' };

export default function CelebrationBanner({ onWatch }) {
  const navigate = useNavigate();

  const handleWatchClick = (e) => {
    if (onWatch) {
      onWatch(e);
    } else {
      navigate("/celebration-video/?watch=1");
    }
  };

  return (
    <div
      className="fixed top-0 left-0 z-[60] hidden h-[var(--celebration-banner-height)] w-full items-center justify-center gap-8 px-4 lg:flex xl:gap-[50px]"
      style={{ background: "linear-gradient(180deg, #020aa4 0%, #22488d 100%)" }}
    >
      <Link
        to="/celebration-video/"
        className="absolute inset-0 z-0"
        aria-label="20 Years of Technology and Innovation — view celebration page"
      />

      <p
        className="pointer-events-none relative z-10 whitespace-nowrap text-[21px] font-medium leading-[1.2] tracking-[0.3px] text-white xl:text-[29px] xl:font-semibold xl:leading-[1.1] xl:tracking-[0.4px]"
        style={MANROPE}
      >
        <span className="font-bold text-[#ebde09]">20 Years</span> of Technology and Innovation
      </p>

      <button
        type="button"
        onClick={handleWatchClick}
        aria-haspopup="dialog"
        style={MANROPE}
        className="relative z-10 flex h-9 w-[190px] shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-[10px] bg-white text-sm font-semibold text-[#22488d] transition-colors hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#22488d] xl:h-[42px] xl:w-[245px] xl:rounded-[11px] xl:text-[18px] xl:tracking-[0.9px]"
      >
        Watch the Celebration
        <span
          className="inline-block h-0 w-0 border-y-[6px] border-l-[9px] border-y-transparent border-l-[#22488d] xl:border-y-[9px] xl:border-l-[13px]"
          aria-hidden="true"
        />
      </button>
    </div>
  );
}
